import {SleepReportData} from "./sleep-report-data";

export function reportFilename(sleepReportData: SleepReportData): string {
  return `${sleepReportData.metadata.code}.pdf`;
}
